import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Marketing icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Marketing } from '@sravni/design-system-icons'
 *
 * <Marketing />
 * ```
 */
var Marketing = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Marketing", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.333 10.13V7.5h-2.63M15.833 5l.834-.833", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 4.167H4.167c-.921 0-1.667.746-1.667 1.666v10c0 .921.746 1.667 1.667 1.667H15c.92 0 1.667-.746 1.667-1.667v-4.166M16.667 7.5h1.175M13.333 4.167V2.992", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M2.5 11.35c6.667 1.498 9.792-2.808 9.792-2.808", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Marketing };
//# sourceMappingURL=Marketing.js.map
